package com.anjuros.website.templates.template1.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_ADDRESS
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_PHONE

enum class Template1CompanyDetails: CompanyDetailsType {
    CLIENTS_EMAIL_INFO {
        override fun value(): String {
            return CLIENTS_EMAIL
        }

        override fun getType(): DetailsType {
            return DetailsType.EMAIL
        }
    },



    CLIENTS_COMPANY_ADDRESS1_INFO {
        override fun value(): String {
            return CLIENTS_ADDRESS
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_ADDRESS
        }
    },

    CLIENTS_PHONE_INFO {
        override fun value(): String {
            return CLIENTS_PHONE
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_PHONE
        }
    },


}